import React from 'react';
import firebase, {auth} from '../firebase';
import * as Yup from 'yup';
import language from '../languages';

const meta = (uid, lang)=> {
    return {
        entityName: language[lang].Profile,
        emptyRow: () => {
            return {
                firstName: '',
                lastName: '',
                email: '',
                profileImageUrl: 'https://via.placeholder.com/800'
            }
        },
        collection: 'users',
        addButtonText: language[lang].New_Profile,
        // addButtonText: () => {
        //     return <>Add New </>
        //     },
        hideTitle: true,
        docPath: uid,
        fields: [
            {name: 'profileImageUrl', default: null, dataType: 'string', label: 'Image', input: 'file', isAvatar: true},
            // {name: 'id', default: null, dataType: 'string', label: 'ID', input: 'text', disabled:true},
            {name: 'firstName', default: null, dataType: 'string', label: 'First Name', input: 'text'},
            {name: 'lastName', default: null, dataType: 'string', label: 'Last Name', input: 'text'},
            {name: 'email', default: null, dataType: 'string', label: 'E-mail', input: 'text', disabled: true},
        ],
        validationSchema: Yup.object({
            firstName: Yup.string()
                .required(language[lang].Field_Required),
            lastName: Yup.string()
                .required(language[lang].Field_Required),
            email: Yup.string()
                .email()
                .required(language[lang].Field_Required)
        }),
        filterObject: [],
        defaultOrderBy: ['firstName', 'desc'],
        searchableColumns: ['firstName','lastName','email'],
        beforeSave: (user, doc)=> {
            if(doc.releaseDate){
                doc.releaseDate = new Date(doc.releaseDate).getTime();
            }
            return doc
        }
    }
}

export default meta;